/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable  no-lonely-if */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { copyStyles, toWindowFeatures } from './utils';
import Spinner from '../spinner/Spinner';

class PopupWindowComponent extends React.PureComponent {
  static defaultProps = {
    url: '',
    name: '',
    title: 'Bottomline Technologies',
    features: { width: '600px', height: '640px' },
    onBlock: null,
    onUnload: null,
    center: 'parent',
    copyStyles: true
  };

  constructor(props) {
    super(props);
    this.container = null;
    this.window = null;
    this.windowCheckerInterval = null;
    this.released = false;

    this.state = {
      mounted: false,
      loadingStyles: true
    };
  }

  componentDidMount() {
    this.openChild();
    if (this.window) {
      this.setState({ mounted: true });
    }
  }

  componentWillUnmount() {
    if (this.window) {
      this.window.close();
    }
  }

  handleCopyingStyles = () => {
    copyStyles(document, this.window.document);
    this.setState({ loadingStyles: false });
  };

  release = () => {
    // This method can be called once.
    if (this.released) {
      return;
    }
    this.released = true;

    // Remove checker interval.
    clearInterval(this.windowCheckerInterval);

    // Call any function bound to the `onUnload` prop.
    const { onUnload } = this.props;

    if (typeof onUnload === 'function') {
      onUnload.call(null);
    }
  };

  openChild = () => {
    const { center, features, name, onBlock, title, url } = this.props;

    // Prepare position of the new window to be centered against the 'parent' window or 'screen'.
    if (
      typeof center === 'string' &&
      (features.width === undefined || features.height === undefined)
    ) {
      /* istanbul ignore next */
      console.warn(
        'width and height window features must be present when a center prop is provided'
      );
    } else if (center === 'parent') {
      features.left = window.top.outerWidth / 2 + window.top.screenX - features.width / 2;
      features.top = window.top.outerHeight / 2 + window.top.screenY - features.height / 2;
    } else if (center === 'screen') {
      const screenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left;
      const screenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top;
      const width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : window.screen.width;
      const height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : window.screen.height;

      features.left = width / 2 - features.width / 2 + screenLeft;
      features.top = height / 2 - features.height / 2 + screenTop;
    }

    // Open a new window.
    this.window = window.open(url, name, toWindowFeatures(features));
    if (!this.window || this.window.closed || typeof this.window.closed === 'undefined') return; // POPUP BLOCKED

    this.container = this.window.document.createElement('div');
    // When a new window use content from a cross-origin there's no way we can attach event
    // to it. Therefore, we need to detect in a interval when the new window was destroyed
    // or was closed.
    this.windowCheckerInterval = setInterval(() => {
      if (!this.window || this.window.closed) {
        this.release();
      }
    }, 50);

    // Check if the new window was succesfully opened.
    if (this.window) {
      this.window.document.title = title;
      this.window.document.body.appendChild(this.container);

      // If specified, copy styles from parent window's document.
      if (this.props.copyStyles) {
        setTimeout(this.handleCopyingStyles, 0);
      }

      // Release anything bound to this component before the new window unload.
      this.window.addEventListener('beforeunload', () => this.release());
    } else {
      // Handle error on opening of new window.
      if (typeof onBlock === 'function') {
        onBlock.call(null);
      } else {
        console.warn('A new window could not be opened. Maybe it was blocked.');
      }
    }
  };

  render() {
    if (!this.state.mounted || !this.container) return <Spinner />;
    return ReactDOM.createPortal(
      this.state.loadingStyles ? <Spinner /> : this.props.children,
      this.container
    );
  }
}

PopupWindowComponent.propTypes = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
  features: PropTypes.shape({}),
  onUnload: PropTypes.func,
  onBlock: PropTypes.func,
  center: PropTypes.oneOf(['parent', 'screen']),
  copyStyles: PropTypes.bool
};

export default PopupWindowComponent;
